
import React from 'react';
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CalendarDay as CalendarDayType } from './types';

interface CalendarDayProps {
  day: CalendarDayType;
  onDateClick: (date: Date) => void;
}

const CalendarDay: React.FC<CalendarDayProps> = ({ day, onDateClick }) => {
  const {
    date,
    dateStr,
    isCurrentMonth,
    isSelected,
    isToday,
    isPast,
    dayColorClass,
    tooltip,
    schedule
  } = day;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onDateClick(date)}
            disabled={isPast || !isCurrentMonth}
            className={cn(
              "h-10 w-10 text-sm rounded-lg transition-all duration-200 relative border",
              isSelected
                ? "bg-blue-600 text-white border-blue-600 shadow-md"
                : isCurrentMonth && !isPast
                ? `${dayColorClass} hover:bg-blue-100 hover:border-blue-300 border-transparent`
                : "text-gray-300 cursor-not-allowed border-transparent",
              isToday && !isSelected
                ? "ring-2 ring-blue-200"
                : ""
            )}
          >
            {format(date, 'd')}
            
            {/* Indicador de horários configurados */}
            {isCurrentMonth && !isPast && schedule?.hasSchedule && !isSelected && (
              <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-blue-500 rounded-full"></div>
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CalendarDay;
